import React from 'react';
import Carousel from './Carousel';
import HolidayPackage from '../pages/HolidayPackage';
import BrandSection from '../pages/BrandSection';
import AboutSection from '../pages/AboutSection ';
import DestinationSection from '../pages/DestinationSection ';
import CategorySection from '../pages/CategorySection';
import TestimonialSection from '../pages/TestimonialSection ';
import BenefitsSection from '../pages/BenefitsSection';
import BlogSection from '../pages/BlogSection ';
import DestinationSectionn from '../pages/DestinationSection';
import VideoSlider from './VideoSlider';



const HeroSection = () => {
  
  return (

    <div className="th-hero-wrapper hero-1" id="hero">
{/* <Carousel/> */}
<VideoSlider/>
<HolidayPackage/>
<BrandSection/>
<AboutSection/>
{/* <DestinationSection
/> */}
<DestinationSectionn/>
<CategorySection/>
<TestimonialSection/>
<BenefitsSection/>
<BlogSection/>

    </div>
  );
};

export default HeroSection;
